import { WsMessageEvent } from "../utils/wsModule";
import { BufferLike, ModifiedWebSocket } from "../utils/websocketModifier.util";
import { IResolverStatic, Resolver } from "../types";
import {
	NormalizedTransfer,
	TransferFlags,
	normalizeTransferFlags,
} from "../transfer";

export abstract class CompressResolver extends Resolver {
	// Кодек кадра на проводе (имя историческое: сжатия может не быть).
	options: {
		session: ModifiedWebSocket;
		transfer: NormalizedTransfer;
	};

	constructor(options: {
		session: ModifiedWebSocket;
		transfer?: TransferFlags | NormalizedTransfer;
	}) {
		super();
		this.options = {
			session: options.session,
			transfer: normalizeTransferFlags(options.transfer as TransferFlags),
		};
	}
	public abstract compress(messageEvent: object): Promise<BufferLike>;
	public abstract decompress(messageEvent: WsMessageEvent): Promise<object>;
}

export interface ICompressResolver extends IResolverStatic {
	new (options: {
		session: ModifiedWebSocket;
		transfer?: TransferFlags | NormalizedTransfer;
	}): CompressResolver;
}
